import React from "react";
import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import VetMap, { VetMapUnavailable } from "./VetMap";
import { vetProfileDetails } from "../../vetProfile.logic";

function VetProfile({ vet: savedVet }) {
	const { detail: vet, coordinates: coords } = vetProfileDetails(savedVet, process.env.VITE_APP_GOOGLE);

	return (
		<React.Fragment>
			<>
				<div className="flex w-full flex-col sm:flex-row gap-11">
					<div className="flex w-full md:w-3/5 h-208">
						{vet.id && (
							<Card key={vet.id} className="flex w-full my-5 flex-col">
								<div className="flex w-full">
									<CardMedia
										className="w-112 p-10 rounded-20"
										component="img"
										image={vet.imageUrl || "assets/img/logo.png"}
										alt={vet.name}
									/>
									<Box sx={{ display: "flex", flexDirection: "column" }}>
										<CardContent sx={{ flex: "1 0 auto" }}>
											<Typography component="div" variant="h5">
												{vet.name}
											</Typography>
											<Typography
												variant="subtitle1"
												color="text.secondary"
												component="div"
											>
												{vet.practiceType}
											</Typography>
										</CardContent>
									</Box>
								</div>
								<div className="flex w-full flex-col px-24">
									<Typography className="flex w-full">
										{vet.phoneNumber}
									</Typography>
									<Typography className="flex w-full">
										{vet.address1}
									</Typography>
								</div>
							</Card>
						)}
					</div>

					<div className="flex w-full md:w-2/5 min-h-[260px]">
						{coords ? (
							<VetMap lat={coords.latitude} lng={coords.longitude} />
						) : <VetMapUnavailable />}
					</div>
				</div>
			</>
		</React.Fragment>
	);
}

export default VetProfile;
